<template>	
	<div class="content min-vh-100 flex-column d-flex justify-content-between">
		<UserPreview />
		<section class="flex-grid-desk">
			<div class="card card-horizontal">
				<router-link to="/insurance">
					<div class="card-body">
						<div class="flex-grow-1">
							<img src="img/ico-highlights.svg" /> Insurance Highlights
						</div>
					</div>
				</router-link>
			</div>
			<div class="card card-horizontal">
				<router-link to="/file-claim">
					<div class="card-body">
						<div class="flex-grow-1">
							<img src="img/ico-claim.svg" /> File Claim
						</div>
					</div>
				</router-link>
			</div>
			<div class="card card-horizontal">
				<router-link to="/contact-us">
					<div class="card-body">
						<div class="flex-grow-1">
							<img src="img/ico-contacts.svg" /> Contact Us
						</div>
					</div>
				</router-link>
			</div>
			<div class="card card-horizontal">
				<a :href="`/public/docs/ins4models-terms_and_conditions_${new Date().getFullYear()}.pdf`" target="_blank" alt="Terms and Conditions">
					<div class="card-body">
						<div class="flex-grow-1">
							<img src="img/ico-policy-conditions.svg" />Policy Terms and Conditions
						</div>
					</div>
				</a>
			</div>
		</section>
		<NeedHelp/>
	</div>			
</template>

<script>
// @ is an alias to /src
import UserPreview from '@/components/UserPreview.vue'
import NeedHelp from '@/components/NeedHelp.vue'

export default {
	name: 'Home',
	components: {
		UserPreview,
		NeedHelp
	}
}
</script>
